import { render, staticRenderFns } from "./ApplicantStudentPriorityOrder.vue?vue&type=template&id=63fe8416&"
import script from "./ApplicantStudentPriorityOrder.vue?vue&type=script&lang=js&"
export * from "./ApplicantStudentPriorityOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports